module.exports = "<a #domInvite class=\"badge\" [ngClass]=\"status\" (click)=\"resendInvitation(id)\">{{label}}</a>\n"